module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap10"
    }
  }, [_vm._v("CHAPTER 10")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("“I"), _c('span', {
    staticClass: "small"
  }, [_vm._v(" HATE THESE MOTHERFUCKERS,” SAID")]), _vm._v(" Agent Pidgeon. She was looking at the photographs of little Karen Morse. What the killer had left of little Karen. Among other things, he had skinned the child and carefully rolled the skin up in salt and tied the package with the ribbons the little girl had had in her hair.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré looked at the FBI agent. She was six feet tall, slender, with big tits and a narrow waist and legs, legs, legs. Heart-shaped face and big brown eyes. Long pale brown hair. Caramel. She had some Indian blood in her, long earlobes. Thick gold earrings. A nice stainless steel Sig Sauer combat 9mm in a holster hung low under her arm. She had her fitted jacket off. She was smoking.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Skeleton was in the bottom of the barrel, this was wrapped up and just lying off in the brush, right?” said Agent Pidgeon. “We’ll go out there tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("You and me and Madelaine go out there tomorrow, thought Du Pré, is how that will work, until Madelaine and you have a little talk. Not that you would want anything to do with a Métis grandfather, but what I think don’t mean shit here, yes.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Uh,” said Benny. “Ma’am, do you want to get some dinner?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“S’pose so,” said Agent Pidgeon. “Keep up my strength. Thanks. I get a little jacked, I see things like this.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yeah,” said Benny. “I know what you mean.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Fuck,” said Agent Pidgeon.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Benny’s glance kept returning to Agent Pidgeon’s tits. He was helpless before their magnificence.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yeah, right, food,” said Agent Pidgeon. She slipped her jacket on and she picked up her attaché case.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The rest of her luggage was piled out in the front of the Sheriff’s office. Three suitcases and a couple big aluminum trunks.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You screen the crime scene?” she said. “Run everything through a sieve?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No,” said Benny.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Agent Pidgeon nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Well,” she said. “Maybe there’s nothing there. You … I dunno. Look, I don’t mean to stalk in here, be a hotshot asshole from the FBI. But maybe he dropped something. Maybe there’s a piece of jewelry. Some damn thing. You got Boy Scouts? Let them help out?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Help out how?” said Benny,")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We could dig up all the earth around the site,” said Agent Pidgeon, “and run it through a screen.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Oh,” said Benny. “I guess so.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Agent Pidgeon looked at Benny. She looked at Du Pré. She shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yeah,” she said. “I am a little hungry.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("When they went out the door of the Sheriff’s office they saw the tan government sedan that Pidgeon had been driving being towed to the garage. Pidgeon had driven at such a rate of speed from Billings that the car had blown up twenty miles down the highway. One rod and piston had gone right through the side of the engine.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré had been closer, so he fetched her after she called Benny’s office on the phone.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("When he had pulled up to the steaming car, off in the barrow pit, he noticed all the luggage piled neatly by the roadside. Agent Pidgeon was sitting on one of the suitcases, legs nicely crossed, smoking a cigarette and looking like an ad for some filter-tip brand.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You Indian?” she said, when Du Pré had loaded her luggage, with her help, and loaded her, and driven off.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Métis,” said Du Pré, “French, Scottish, Cree, Chippewa—we are the Mixed Bloods.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Hum,” said Agent Pidgeon, “I’m a Redbone myself. Black, Cherokee, white, Mexican, French …”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Oh,” said Du Pré. “You are Louisiana.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Some of my folks were,” said Pidgeon. “Me, I’m pure California surfin’ girl. Grew up in Coronado. Drink Dos Equis, get tan. Wear gold chains.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“How you get to the FBI?” said Du Pré.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“They needed me,” said Agent Pidgeon, “I’m so many nice minority groups. Besides, after Georgetown Law School I was pretty well convinced that I would be a lot happier putting scum in jail than I would be keeping them out of it. Did a stint in the D.C. Public Defender’s Office. That’ll do it for ya.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Oh,” said Du Pré.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I am not a nice person,” said Agent Pidgeon.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Uh,” said Du Pré.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You seem like a smart man,” said Agent Pidgeon.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Huh?” said Du Pré.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yup,” said Agent Pidgeon.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré shrugged. He rolled himself a cigarette with his left hand as he was shooting down the highway at eighty.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Agent Pidgeon looked at him doing it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré lit his cigarette.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Let me try that,” said Agent Pidgeon.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré handed her the papers and the little bag of Bull Durham.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You are a psychologist?” said Du Pré.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What do you think?” said Agent Pidgeon.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“That Georgetown is a pretty good law school, yes?” said Du Pré.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“They think so,” said Agent Pidgeon.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Where you get your psychology degree?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Columbia,” said Agent Pidgeon. “They thought they were a pretty good psychology school, they said so.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“OK,” said Agent Pidgeon. “What matters to me is we catch this guy and send him up forever or fry the fucker, either one’ll do. If we do that, then they were good schools, if not, they ain’t shit.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré roared.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Harvey said I’d like you,” said Agent Pidgeon. “He also said you were a good guy and not to beat up on Benny Klein, who is a good guy, too, but not that much of a cop.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Benny, he is a small rancher,” said Du Pré. “He is maybe too kind a man to do this well.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I imagine he does fine,” Agent Pidgeon had said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré thought about all this while he drove Agent Pidgeon to the bar in Toussaint, which had the only real food in the area.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("There were a few people in the bar. Agent Pidgeon looked around the shabby big room, at the mangy deer and elk heads and the ratty bear skin nailed to one wall. She nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She walked over to the bar and leaned over to Susan Klein and she said a few words and then she fished a little gift out of her attaché case. Susan laughed and took it and she turned it around in her hand and then she took the ribbon and paper off it. She lifted the lid of the little box and took out a pair of silver earrings, big circles of metal with strands of beads hanging in the center hole.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré looked on and he grinned. That Harvey Weasel Fat, always sucking up to them women. Smart man, that Harvey.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The door opened behind Du Pré and Madelaine came in with Lourdes in tow. They were laughing. They hugged Du Pré.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“That is that Agent Pidgeon,” said Madelaine, hissing into Du Pré’s ear. “Some set of tits she got, there. I think maybe I watch the two of you pret’ good.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“She don’t want some broke-down Métis,” said Du Pré.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Good thing, too,” said Madelaine.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Agent Pidgeon had turned around and she was looking at Du Pré and Madelaine and Lourdes. She came over.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Madelaine?” said Agent Pidgeon. “Harvey said that you were the best thing about Du Pré, here. And this is Lourdes?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yes. Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Um,” said Agent Pidgeon. “We could get a table.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They found an empty table with four chairs and they sat. Susan Klein came over.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I know what they want, dear,” she said. “How about you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Red wine?” said Pidgeon.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Cabernet?” said Susan. “It’s pretty good. What I drink.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Wonderful.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Steaks are good,” said Susan. “The special is gone, sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Rare,” said Pidgeon.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“OK,” said Susan. She went off.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Harvey sends his love,” said Pidgeon.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Ah, he is such a good dancer,” said Madelaine.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré looked at the ceiling.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Nice man, too,” said Madelaine.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Harvey?” said Pidgeon. “Harvey maybe changes he comes out here. Back there he’s a giant pain in the ass. Always staring at my tits and wondering when I am going to get what he needs out of the computer.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“He is a guy,” said Madelaine. “They got only the two heads, think with the little one, they all belong, hospitals.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Mama!” said Lourdes.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“My daughter, she wants me in a cage,” said Madelaine.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Lourdes was blushing.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Why she run away? thought Du Pré. He hadn’t been told.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Lourdes,” said Pidgeon. “This Challis guy who brought you back here? How did he pick you up?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Lourdes looked down at her lap. Her lower lip quivered.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Pidgeon reached over and she patted Lourdes’s hand.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It’s OK, honey,” she said, “as long as you’re all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré looked at Lourdes.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I wonder any of us know any of us, he thought.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d82d11a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/14chap10.vue
// module id = 111
// module chunks = 0